import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Disabled from './panel/Disabled';
import Uploaddocuments from './panel/Uploaddocuments';
import Property from './components/Property';
import Notfound from './panel/Notfound';
import Roomdetails from './components/Roomdetails';
import Roomfacilities from './components/Roomfacilities';
import Amenities from './components/Amenities';
import Rules from './components/Rules';
import Propimages from './components/Propimages';
import Rateplans from './components/Rateplans';
import Roomtarrifs from './components/Roomtarrifs';
import Roomavailability from './components/Roomavailability';
import Help from './panel/Help';
import Roomno from './components/Roomno';
import Rateupdates from './components/Rateupdates';
import Roomrates from './components/Roomrates';
import Userlogins from './components/Userlogins';
import Paymodes from './components/Paymodes';
import Bookingtypes from './components/Bookingtypes';
import Extraservices from './components/Extraservices';

import Viewreservations from './components/reservations/Viewreservations';
import Reservationdetails from './components/reservations/Reservationdetails';
import Checkouts from './components/reservations/Checkouts';
import Hotelinvoice from './components/reservations/Hotelinvoice';
import Roomcleaned from './components/reservations/Roomcleaned';
import Roomcleanings from './components/reservations/Roomcleaning';
import Reserveroom from './components/reservations/Reserveroom';

import Pendingpayments from './components/reports/Pendingpayments';
import Allbookingreport from './components/reports/Addbookingreport';
import Receptionistreport from './components/reports/Receptionistreport';
import Logindetails from './components/reports/Logindetails';
import Userlogs from './components/reports/Userlogs';
import Paymodewise from './components/reports/Paymodewise';
import Bookingtypewise from './components/reports/Bookingtypewise';
import Roomtypewiseonline from './components/reports/Roomtypewise';
import Datewisebooking from './components/reports/Datewisebooking';
import Damagenotes from './components/reports/Damagenotes';
import Cmconnection from './components/Cmconnection';
import Pendingreservations from './components/reservations/Pendingreservations';

import RoomList from './components/cmconnection/Roomlist';
import Otainfo from './components/cmconnection/Otainfo';
import Rateudates from './components/cmconnection/Rateudates';
import Inventiryupdate from './components/cmconnection/Inventiryupdate';

import Wallethistory from './components/Wallethistory';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setLoading(false); // Auth check is complete
    });
    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  // Show a dark-themed loading screen while checking Firebase Auth status
  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', backgroundColor: '#0a1014', color: '#caff6b' }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div className="wrapper" style={{ backgroundColor: '#0a1014', color: '#ffffff', minHeight: '100vh' }}>
      <Router>
        {!user ? (
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/Register' element={<Register />} />
            <Route path='/forgot-password' element={<Forgetpass />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        ) : (
          <div style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
            <Menu />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Header />
              <main style={{ flex: 1, overflowY: 'auto' }}>
                <Routes>
                  <Route path='/wallet-history/:propertyId' element={<Wallethistory />} />

                  <Route path='/inventory-updates' element={<Inventiryupdate />} />
                  <Route path='/rate-updates' element={<Rateudates />} />
                  <Route path='/ota-info' element={<Otainfo />} />
                  <Route path='/room-list' element={<RoomList />} />

                  <Route path='/dcr-report' element={<Allbookingreport />} />
                  <Route path='/reserve-room' element={<Reserveroom />} />
                  <Route path='/receptionist-report' element={<Receptionistreport />} />
                  <Route path='/login-details' element={<Logindetails />} />
                  <Route path='/user-logs' element={<Userlogs />} />
                  <Route path='/paymodewise-report' element={<Paymodewise />} />
                  <Route path='/booking-typewise-report' element={<Bookingtypewise />} />
                  <Route path='/roomtypewise-report' element={<Roomtypewiseonline />} />
                  <Route path='/datewise-bookings' element={<Datewisebooking />} />
                  <Route path='/pending-payments' element={<Pendingpayments />} />

                  <Route path='/cleaned-rooms' element={<Roomcleaned />} />
                  <Route path='/cleaning-rooms' element={<Roomcleanings />} />
                  <Route path='/print-invoice/:documentId' element={<Hotelinvoice />} />
                  <Route path='/checkouts' element={<Checkouts />} />
                  <Route path='/reservation-details/:documentId' element={<Reservationdetails />} />
                  <Route path='/live-reservations' element={<Viewreservations />} />
                  <Route path='/live-reservations' element={<Viewreservations />} />
                  <Route path='/pending-reservations' element={<Pendingreservations />} />

                  <Route path='/' element={<Dashboard />} />
                  <Route path='/home' element={<Dashboard />} />
                  <Route path='/disabled-property' element={<Disabled />} />
                  <Route path='/property-documents' element={<Uploaddocuments />} />
                  <Route path='/property-details' element={<Property />} />
                  <Route path='/room-types' element={<Roomdetails />} />
                  <Route path='/room-information' element={<Roomno />} />
                  <Route path='/room-facilities' element={<Roomfacilities />} />
                  <Route path='/amenties' element={<Amenities />} />
                  <Route path='/rules-and-regulations' element={<Rules />} />
                  <Route path='/property-images' element={<Propimages />} />
                  <Route path='/rate-plans' element={<Rateplans />} />
                  <Route path='/room-rate-plans' element={<Roomtarrifs />} />
                  <Route path='/room-availability' element={<Roomavailability />} />
                  <Route path='/help-support' element={<Help />} />
                  <Route path='/rates-updates' element={<Rateupdates />} />
                  <Route path='/room-rates' element={<Roomrates />} />
                  <Route path='/user-logins' element={<Userlogins />} />
                  <Route path='/payment-modes' element={<Paymodes />} />
                  <Route path='/booking-types' element={<Bookingtypes />} />
                  <Route path='/extra-services' element={<Extraservices />} />
                  <Route path='/damage-notes' element={<Damagenotes />} />
                  <Route path='/channel-manager-connectivity' element={<Cmconnection />} />

                  {/* Catch-all route */}
                  <Route path='*' element={<Notfound />} />
                </Routes>
              </main>

              {/* <Footer /> */}
            </div>
          </div>
        )}
      </Router>
    </div>
  );
}

export default App;